import { Email as ResponseEmail } from "@/Common/Api/Contacts/Dto/Email";
import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";

class Email {
    public ContactPoint_id: string;
    public Address: string;
    public IsOkToContact: boolean;
    public IsValid: boolean = true;
    public AvailableContactPointTypeLookupIds: FlatLookupView[];
    public ContactPointTypeLookupId: string;
    public isSelectedForNotification: boolean;

    constructor() {
        this.ContactPoint_id = GuidHelper.Empty();
        this.Address = "";
        this.IsOkToContact = false;
        this.AvailableContactPointTypeLookupIds = [];
    }

    public static FromResponseModel(response: ResponseEmail): Email {
        var email = new Email();

        email.Address = response.Address;
        email.IsOkToContact = response.IsOkToContact;
        email.IsValid = response.IsValid;
        email.ContactPoint_id = response.ContactPoint_id;
        email.ContactPointTypeLookupId = response.ContactPointTypeLookupId;
        email.isSelectedForNotification = response.isSelectedForNotification;

        return email;
    }
}

export { Email };
